import nSh1 from "./ns-hook (1).png";
import nSh2 from "./ns-hook (2).png";
import nSh3 from "./ns-hook (3).png";

const nSh = [nSh1, nSh2, nSh3];

export default nSh;
